
/**
 * 주문 상태
 */
export type GetOrderById200Status = typeof GetOrderById200Status[keyof typeof GetOrderById200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderById200Status = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;
